import Component from './tag_input.vue'
export default Component
